"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchInput = exports.DetailsTable = exports.NoPaddingCell = exports.BlueHeader = exports.RedHeader = exports.BlueCell = exports.RedCell = exports.Cell = exports.Header = exports.ResultTable = exports.Table = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Table = styled_components_1.default.table `
  margin: 10px;

  tr {
    td {
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }
`;
exports.ResultTable = styled_components_1.default.table `
  border: 1px solid #aaa;
`;
exports.Header = styled_components_1.default.th `
  padding: 8px;
  border: 1px solid #aaa;
`;
exports.Cell = styled_components_1.default.td `
  padding: 8px;
  border: 1px solid #aaa;
`;
exports.RedCell = (0, styled_components_1.default)(exports.Cell) `
  background-color: #dea1a1;
`;
exports.BlueCell = (0, styled_components_1.default)(exports.Cell) `
  background-color: #99c1f1;
`;
exports.RedHeader = (0, styled_components_1.default)(exports.Header) `
  background-color: #dea1a1;
`;
exports.BlueHeader = (0, styled_components_1.default)(exports.Header) `
  background-color: #99c1f1;
`;
exports.NoPaddingCell = (0, styled_components_1.default)(exports.Cell) `
  padding: 0px;
`;
exports.DetailsTable = styled_components_1.default.table `
  tr:first-child {
    th {
      border-top: 0;
    }
  }
  tr:last-child {
    td {
      border-bottom: 0;
    }
  }
  tr {
    th:first-child {
      border-left: 0;
    }
    th:last-child {
      border-right: 0;
    }
    td:first-child {
      border-left: 0;
    }
    td:last-child {
      border-right: 0;
    }
  }
`;
exports.BatchInput = styled_components_1.default.input `
  margin-top: 8px;
  width: 50px;
`;
//# sourceMappingURL=elements.js.map